import { all, call, put, takeLatest } from "redux-saga/effects";
import { request } from "@app/services";

import * as endpoints from "./endpoints";
import { addReview, addReviewFailed, addReviewSuccess, getAvgReviews, getAvgReviewsFailed, getAvgReviewsSuccess, getReviews, getReviewsFailed, getReviewsSuccess, views,viewsFailed,viewsSuccess } from "./slice";

//--------------------viewsSagas-------------------------

function* viewsSaga(action: ReturnType<typeof views>): any {
  try {
    const { carId } = action.payload;
    
    const response = yield call(
      request.post,
      endpoints.view,{carId: Number(carId)});
    yield put(viewsSuccess(response));
  } catch (error: any) {
    yield put(viewsFailed(error));
  }
}

//--------------------getReviewSagas-------------------------

function* getReviewsSaga(action: ReturnType<typeof getReviews>): any {
  try {
    const { carId, page = 1, limit=5} = action.payload;
    const response = yield call(
      request.get,
      `${endpoints.getReviewsById}/${Number(carId)}?page=${Number(page)}&limit=${Number(limit)}`);
    yield put(getReviewsSuccess(response));
  } catch (error: any) {
    yield put(getReviewsFailed(error));
  }
}

//--------------------getAverageSagas-------------------------

function* getAverageSaga(action: ReturnType<typeof getAvgReviews>): any {
  try {
    const { carId} = action.payload;
    const response = yield call(
      request.get,
      `${endpoints.getAverageReviewsById}/${Number(carId)}`);
    yield put(getAvgReviewsSuccess(response));
  } catch (error: any) {
    yield put(getAvgReviewsFailed(error));
  }
}

//--------------------addReviewsSaga-------------------------

function* addReviewsSaga(action: ReturnType<typeof addReview>): any {
  try {
    const {rating, comment, carId} = action.payload;
    const response = yield call(
      request.post,
      endpoints.addReview,{rating,comment,carId: Number(carId)});
    yield put(addReviewSuccess(response));
  } catch (error: any) {
    yield put(addReviewFailed(error));
  }
}

function* viewsSagas() {
  yield all([takeLatest(views, viewsSaga), takeLatest(getReviews, getReviewsSaga), takeLatest(getAvgReviews, getAverageSaga), takeLatest(addReview,addReviewsSaga)]);
}

export { viewsSagas };
